import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const version = process.env.REACT_APP_VERSION || '0.0.0';

  return (
    <Box sx={{ mt: 'auto', py: 2 }}>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Sonic Operations Manager (SonOps) - Version {version}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          © {currentYear} Sonic Internet & Voice Pty Ltd. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
